'use strict';

customerZone
    .service('CityProvider', ['$http', '$q', 'config', 'errorCode', function($http, $q, config, errorCode) {

        var citiesPromise;

        this.getCities = function(){
            if (citiesPromise) return citiesPromise;
            citiesPromise = $http.get(config.baseUrl + '/data/postalcodes.json')
                .then(function(results){
                    var language = config.language.substr(0, 2);
                    return results.data[language] || [];
                }, unwrapError);
            return citiesPromise;
        };

        /**
         * Unwrap given error and map fields if the error contains some using the given mapping.
         */
        var unwrapError = function(response){
            if (response.status <= 0 || response.status === 408)
                throw errorCode.wrap(errorCode.HTTP_CONNECTION_ERROR);
            else if (response.status === 429)
                throw errorCode.wrap(errorCode.REQUEST_THROTTLED, response.data);
            else if (Math.floor(response.status/100) === 4)
                throw errorCode.wrap(errorCode.CLIENT_ERROR, response.data);
            else
                throw errorCode.wrap(errorCode.SERVER_ERROR, response.data);
        };
    }]);
